import { normalizeAssetTypeName } from '../constants/filterableAssetTypes';
import { assetIsParkingBooking } from './assetIsParkingBooking';
import { assetRecordAssetTypeId } from './homeCarouselAssetMatch';

/** Asset types that track headcount on bookings (open space, gym, business lounge — not parking). */
const PEOPLE_COUNT_TYPE_IDS = new Set([
  2, // Open Space
  9, // Gym
  15, // Business Lounge
]);

const PEOPLE_COUNT_TYPE_LABELS = new Set(
  [
    'Open Space',
    'Gym',
    'Training Room',
    'Fitness',
    'Fitness Center',
    'Business Lounge',
  ].map((label) => normalizeAssetTypeName(label)),
);

function assetTypeNameBag(asset: Record<string, unknown>): Set<string> {
  const bag = new Set<string>();
  const add = (raw: unknown) => {
    if (typeof raw === 'string' && raw.trim()) {
      bag.add(normalizeAssetTypeName(raw));
    }
  };
  add(asset.asset_type_name);
  add(asset.assetTypeName);
  add(asset.type_name);
  add(asset.type);
  if (typeof asset.asset_type === 'string') {
    add(asset.asset_type);
  }
  if (asset.asset_type !== null && typeof asset.asset_type === 'object' && !Array.isArray(asset.asset_type)) {
    const nested = asset.asset_type as Record<string, unknown>;
    add(nested.name);
    add(nested.label);
    add(nested.type_name);
    add(nested.title);
  }
  return bag;
}

/** Whether the quick-booking UI should expose a people-count field for this asset. */
export function assetBookingShowsPeopleCount(asset: Record<string, unknown>): boolean {
  if (assetIsParkingBooking(asset)) {
    return false;
  }
  const typeId = assetRecordAssetTypeId(asset);
  if (typeId !== null && PEOPLE_COUNT_TYPE_IDS.has(typeId)) {
    return true;
  }
  return Array.from(assetTypeNameBag(asset)).some((name) => PEOPLE_COUNT_TYPE_LABELS.has(name));
}

/** True when any loaded asset/booking record indicates guest count applies. */
export function bookingConfirmationShowsPeopleCount(
  sources: Array<Record<string, unknown> | null | undefined>,
): boolean {
  for (const source of sources) {
    if (source && assetBookingShowsPeopleCount(source)) {
      return true;
    }
  }
  return false;
}
